var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }